export default {"src":"/_next/static/media/FNV.33807c1a.svg","height":18,"width":18};